import styled from "@emotion/styled";
import { styled as muiStyled } from "@mui/system";
import { globalColors } from "../../Utils/colors";
import { ExtendedTypographyOptions } from "./type";

import {
  Card,
  ThemeOptions,
  checkboxClasses,
  createTheme,
} from "@mui/material";

export const getCardContainerTheme = () => {
  return createTheme({
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: globalColors.cardBackgroundColor,
            borderRadius: 10,
            maxHeight: 310,
            minWidth: 275,
          },
        },
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            padding: "8px 16px",
          },
          content: {
            width: "100%",
          },
        },
      },
      MuiCardMedia: {
        styleOverrides: {
          root: {
            margin: "0px 15px",
            width: "calc(100% - 30px)",
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            [`&, &.${checkboxClasses.checked}`]: {
              color: globalColors.primary,
            },
          },
        },
      },
    },
    typography: {
      editedOn: {
        color: globalColors.textGrey,
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
      },
    } as ExtendedTypographyOptions,
  } as ThemeOptions);
};

export const CardMediaParentContainer = styled("div")({
  position: "relative",
});

export const CardMediaTextContainer = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: globalColors.white,
  maxWidth: "90%",
  maxHeight: "100%",
  overflow: "hidden"
});

export const CardHeaderParentContainer = styled("div")({
  alignItems: "center",
  display: "flex",
});

export const CardHeaderTextContainer = muiStyled("div", {
  shouldForwardProp: (prop) => prop !== "multiDelete",
})<{
  multiDelete?: boolean;
}>(({ multiDelete }) => ({
  color: globalColors.headingBlack,
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: 700,
  width: multiDelete ? "calc(100% - 82px)" : "calc(100% - 40px)",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
}));

export const CardHeaderIconsContainer = styled("div")({
  alignItems: "center",
  display: "flex",
});

export const StyledCardContainer = muiStyled(Card, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "multiDelete",
})<{
  isSelected?: boolean;
  multiDelete?: boolean;
}>(({ multiDelete, isSelected }) => ({
  cursor: "pointer",
  filter: multiDelete
    ? isSelected
      ? "unset"
      : "opacity(.5)"
    : "unset",
}));
